
import React, { useState, useEffect } from "react";

export function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className="fixed top-4 left-1/2 z-50 transition-all duration-500 ease-out"
      style={{
        transform: `translateX(-50%) ${scrolled ? 'scale(0.95)' : 'scale(1)'}`,
        width: scrolled ? '90%' : '95%',
        maxWidth: '1200px',
      }}
    >
      <div
        className="relative overflow-hidden transition-all duration-500 ease-out"
        style={{
          background: scrolled
            ? 'rgba(15, 10, 21, 0.85)'
            : 'rgba(15, 10, 21, 0.7)',
          backdropFilter: 'blur(20px) saturate(180%)',
          WebkitBackdropFilter: 'blur(20px) saturate(180%)',
          borderRadius: scrolled ? '20px' : '24px',
          border: '1px solid rgba(203, 108, 230, 0.2)',
          boxShadow: scrolled
            ? `
              0 10px 40px rgba(0, 0, 0, 0.4),
              0 0 0 1px rgba(203, 108, 230, 0.15),
              inset 0 1px 0 rgba(255, 255, 255, 0.08)
            `
            : `
              0 8px 32px rgba(0, 0, 0, 0.3),
              0 0 0 1px rgba(203, 108, 230, 0.12),
              inset 0 1px 0 rgba(255, 255, 255, 0.06)
            `,
        }}
      >
        <div className="px-6 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="relative">
                <div
                  className="p-2 rounded-xl relative overflow-hidden transition-all duration-300 flex items-center justify-center"
                  style={{
                    background: 'linear-gradient(135deg, #cb6ce6 0%, #a855f7 100%)',
                    boxShadow: '0 4px 12px rgba(203, 108, 230, 0.3)',
                    width: '40px',
                    height: '40px',
                  }}
                >
                  <span
                    style={{
                      fontSize: '20px',
                      fontWeight: '700',
                      color: '#ffffff',
                      fontFamily: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                    }}
                  >
                    Ø
                  </span>
                </div>
              </div>
            </div>

            <nav className="flex items-center gap-2">
              {[
                { label: 'Dev Docs', href: '#docs' },
                { label: 'Bridge Funds', href: '#bridge' },
                { label: 'Explorer', href: '#explorer' },
              ].map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="px-4 py-2 rounded-lg transition-all duration-200 relative group"
                  style={{
                    color: '#94a3b8',
                    fontFamily:
                      'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                    fontSize: '14px',
                    fontWeight: '500',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#f1f5f9';
                    e.currentTarget.style.background = 'rgba(203, 108, 230, 0.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#94a3b8';
                    e.currentTarget.style.background = 'transparent';
                  }}
                >
                  {item.label}
                </a>
              ))}
            </nav>

            <div className="flex items-center gap-3">
              <button
                className="px-5 py-2.5 rounded-xl transition-all duration-300 relative overflow-hidden"
                style={{
                  background: 'linear-gradient(135deg, #cb6ce6 0%, #a855f7 100%)',
                  color: '#ffffff',
                  fontFamily:
                    'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  fontSize: '14px',
                  fontWeight: '600',
                  border: 'none',
                  cursor: 'pointer',
                  boxShadow: '0 4px 12px rgba(203, 108, 230, 0.4)',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(203, 108, 230, 0.6)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(203, 108, 230, 0.4)';
                }}
              >
                Enter Portal
              </button>
              <button
                className="px-5 py-2.5 rounded-xl transition-all duration-300"
                style={{
                  background: 'rgba(255, 255, 255, 0.95)',
                  color: '#0f0a15',
                  fontFamily:
                    'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  fontSize: '14px',
                  fontWeight: '600',
                  border: 'none',
                  cursor: 'pointer',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.15)';
                  e.currentTarget.style.background = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.95)';
                }}
              >
                Add Network to Wallet
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
